"use strict";

import AppendableEvents from "./react/AppendableEvents";

export const auth = true;
export const title = "i18n:appendableEvents.nearbyEvents";
export const Component = AppendableEvents;
